import React from "react";
import Header from "../components/header/Header";
import SettingsForm from "../components/forms/SettingsForm";
import Footer from "../components/footer/Footer";
const Settings = () => {
  return (
    <div>
        <Header />
        <SettingsForm />
        <Footer/>
    </div>
  )
};

export default Settings;
